/* src/app/components/info-modal/info-modal.component.scss */
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 35px;
  margin: 0;
  border-radius: 16px;
  background: #f6f1ef;
}
.container .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.container .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.container .cross-icon:hover {
  background: #f2dbd9;
}
.title {
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 8px;
  text-transform: uppercase;
}
.info {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
}
.button {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 25px;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: #ebdfda;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  border-radius: 26px;
  text-transform: uppercase;
}
.button_main:hover {
  background: #f2dbd9;
}
.button_close {
  background: transparent;
  text-transform: uppercase;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  border-radius: 26px;
  color: var(--color-black);
}
.button_close:hover {
  background: #f2dbd9;
}
/*# sourceMappingURL=info-modal.component.css.map */
